<template>
    <v-dialog v-model="showPrompt" max-width="320" persistent transition="dialog-scale-transition">
        <v-card class="pa-6" style="
        border-radius: 22px;
        box-shadow: 0px 10px 32px rgba(0,0,0,0.25);
      ">
            <!-- App Logo -->
            <div class="text-center mb-4">
                <v-avatar size="72" class="elevation-6">
                    <img src="../../assets/logo/ic_launcher.png" alt="App Icon" />
                </v-avatar>
            </div>

            <!-- Title -->
            <div class="text-center mb-2 propt-title text-not-break">
                Use the SUS App?
            </div>

            <!-- Subtitle -->
            <div class="text-center mb-6 prompt-subtitle text-not-break">
                Enjoy a smoother and faster experience with our mobile app.
            </div>

            <!-- Primary CTA -->
            <v-btn block large class="white--text py-3 app-btn" @click="onUseApp">
                <v-icon left size="22">mdi-cellphone</v-icon>
                Use App
            </v-btn>

            <!-- Secondary CTA -->
            <v-btn block text large class="mt-4 app-continue" @click="onContinueInBrowser">
                Continue in Browser
            </v-btn>

        </v-card>
    </v-dialog>
</template>

<script>
    import { ANDROID_INTENT_URL } from "@/utils/appLinks";

    export default {
        name: "AppInstallPrompt",

        data() {
            return {
                showPrompt: false,
            };
        },

        computed: {
            isAndroid() {
                return /android/i.test(navigator.userAgent);
            },
            isIOS() {
                return /iphone|ipad|ipod/i.test(navigator.userAgent);
            },
        },

        mounted() {
            this.maybeShowPrompt();
        },

        methods: {
            maybeShowPrompt() {
                // Only show on mobile browsers
                if (!this.isAndroid && !this.isIOS) return;

                // Show only once (per browser) – remove this if you want it every visit
                // const alreadyShown = localStorage.getItem("sus_app_prompt_shown");
                // if (alreadyShown === "yes") return;
                const expiresAt = localStorage.getItem("sus_app_prompt_expires");

                // If expiration exists and 2 hours not passed → don't show
                if (expiresAt && Date.now() < parseInt(expiresAt)) {
                    return;
                }

                this.showPrompt = true;
            },

            onUseApp() {
                if (this.isAndroid) {
                    // Try to open app; if not installed, goes to Play Store because of
                    // browser_fallback_url inside ANDROID_INTENT_URL
                    window.location.href = ANDROID_INTENT_URL;
                } else if (this.isIOS) {
                    // iOS app is still in development.
                    // When your iOS app is live, replace this with the App Store URL.
                    alert("The iOS app is under development. Please continue in browser for now.");
                }

                // Remember user choice so we don't bug them next time
                //localStorage.setItem("sus_app_prompt_shown", "yes");
                const expireAt = Date.now() + 2 * 60 * 60 * 1000; // 5 minutes (for testing)
                localStorage.setItem("sus_app_prompt_expires", expireAt.toString());
                this.showPrompt = false;
            },

            onContinueInBrowser() {
                const expireAt = Date.now() + 2 * 60 * 60 * 1000; // 5 minutes (for testing)
                localStorage.setItem("sus_app_prompt_expires", expireAt.toString());
                this.showPrompt = false;
            },
        },
    };
</script>

<style scoped>
    /* ✨ Premium Scale Animation */
    .dialog-scale-transition-enter-active {
        animation: scaleIn 0.28s ease-out;
    }

    .propt-title {
        font-size: 20px;
        font-weight: 700;
        color: #222;
    }

    .prompt-subtitle {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
    }

    .app-btn {
        border-radius: 12px;
        font-weight: 600;
        font-size: 15px;
        background: linear-gradient(135deg, #3f8cff, #0069ff);
    }
    .app-continue {
        font-weight: 600; color:#777;
    }
    @keyframes scaleIn {
        from {
            transform: scale(0.85);
            opacity: 0;
        }

        to {
            transform: scale(1);
            opacity: 1;
        }
    }
</style>